import debounce from 'lodash.debounce';
import { STORAGE } from '@/helpers/constants';
import usersServices from '@/services/usersServices';
import { SET_OVERVIEW_FILTERS, SET_OVERVIEW_FILTERS_FOCUS } from '../types';

const saveFilters = (userConfig) => {
  usersServices.saveUsersConfig(sessionStorage.getItem(STORAGE.USER_CODE), userConfig)
    // eslint-disable-next-line no-console
    .catch(console.error);
};

const initialState = {};

const debouncedSaveFilters = debounce(saveFilters, 1000);

export default (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case SET_OVERVIEW_FILTERS: {
      newState = { ...state, ...action.payload };
      debouncedSaveFilters({ ...action.userConfig, ...newState });

      return newState;
    }

    case SET_OVERVIEW_FILTERS_FOCUS: {
      newState = { ...state, filterToFocus: action.payload };

      return newState;
    }

    default:
      break;
  }

  return {
    ...state,
    ...newState,
  };
};

const memoizeJsonParse = () => {
  let lastInput;
  let lastOutput;

  return (input) => {
    if (input !== lastInput) {
      lastInput = input;
      lastOutput = input ? JSON.parse(input) : null;
    }

    return lastOutput;
  };
};

const parseSortOverview = memoizeJsonParse();
const parseFilterOverview = memoizeJsonParse();
const parsePillOverview = memoizeJsonParse();
const parseOrderColumnsOverview = memoizeJsonParse();
const parseWidthColumnsOverview = memoizeJsonParse();
const parseVisibilityColumnsOverview = memoizeJsonParse();
const parsePillSubCROverview = memoizeJsonParse();
const parseFilterSubCROverview = memoizeJsonParse();
const parseSortSubCROverview = memoizeJsonParse();

export const getFiltersConfig = (state) => state.overviewFiltersReducer;
export const getSortOverview = (state) => parseSortOverview(state.overviewFiltersReducer.sortOverview);
export const getFilterOverview = (state) => parseFilterOverview(state.overviewFiltersReducer.filterOverview);
export const getPillOverview = (state) => parsePillOverview(state.overviewFiltersReducer.pillFilterOverview);
export const getRowsPerPageCR = (state) => +state.overviewFiltersReducer.rowsPerPageOverview;
export const getOrderColumnsOverview = (state) => parseOrderColumnsOverview(state.overviewFiltersReducer.orderColumnsOverview);
export const getWidthColumnsOverview = (state) => parseWidthColumnsOverview(state.overviewFiltersReducer.widthColumnsOverview);
export const getVisibilityColumnsOverview = (state) => parseVisibilityColumnsOverview(state.overviewFiltersReducer.visibilityColumnsOverview);

// Deprecated subcr overview
export const getRowsPerPageSubCR = (state) => +state.overviewFiltersReducer.rowsPerPageSubCampaignOverview;
export const getPillSubCROverview = (state) => parsePillSubCROverview(state.overviewFiltersReducer.pillFilterSubCampaignOverview);
export const getFilterSubCROverview = (state) => parseFilterSubCROverview(state.overviewFiltersReducer.filterSubCampaignOverview);
export const getSortSubCROverview = (state) => parseSortSubCROverview(state.overviewFiltersReducer.sortSubCampaignOverview);

export const getFilterToFocus = (state) => (state.overviewFiltersReducer.filterToFocus
  ? state.overviewFiltersReducer.filterToFocus
  : null);
